import React from 'react';
import CategorySlider, { Props as CategorySliderProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/category-slider';
import { LOOM_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';

export interface Props {
  children?: React.ReactNode;
  data: CategorySliderProps;
}

const CategorySliderTastic: React.FC<Props> = ({ data }) => {
  return (
    <CategorySlider
      {...data}
      tileLabelClassName={LOOM_CONTENT_LOOK.categoryTileLabelClassName}
      background={LOOM_CONTENT_LOOK.categorySliderBackground}
    />
  );
};

export default CategorySliderTastic;
